import TextContainer from "./TextContainer";
import { Row, Col } from "./Flexbox";
import Text from "./Text";
import { Input, SelectField, fieldRow } from "./FormField";
import {RewindIcons} from "./icons/Icons";
import { Controller, useWatch } from "react-hook-form";

const PRODUCTION_OPTIONS = {
    suajeItems: [
        { value: "Null", label: "Null" },
        { value: "HerrNueva", label: "Herramienta nueva" },
        { value: "HerrExist", label: "Herramienta existente" }
    ],

    tipoPlastItems: [
        { value: "Brillante", label: "Brillante" },
        { value: "Mate", label: "Mate" }
    ],

    aplicPlastItems: [
        { value: "Plasta", label: "Plasta" },
        { value: "Registro", label: "Registro" }
    ],

    carasPlastItems: [
        { value: "Frente", label: "Frente" },
        { value: "Vuelta", label: "Vuelta" }
    ],

    barnizItems: [
        { value: "AcrBrill", label: "Acrílico brillante" },
        { value: "AcrMate", label: "Acrílico mate" },
        { value: "Termo", label: "Termosellante" }
    ],

    aplicBarnizItems: [
        { value: "Plasta", label: "Plasta" },
        { value: "Registro", label: "Registro" }
    ],

    carasBarnizItems: [
        { value: "Frente", label: "Frente" },
        { value: "Vuelta", label: "Vuelta" }
    ],

    pegadoItems : [
        {value: "Linea", label: "Linea"},
        {value: "F. Autom", label: "F. Autom"}
    ],

    rebobinadoItems : [
        {value: "AVT", label: "AVT"},
        {value: "Normal", label: "Normal"}
    ]
}

const TechSpecsEnd = ({theme, control}) => {

    const format = useWatch({control, name: "format"});
    const activeFinishes = useWatch({control, name: "activeFinishes"}) || [];

    return(
        <Col style={{width: '100%', justifyContent: 'space-between', marginTop: 64, marginBottom: 64}}>
            <Col style={{width: '100%', alignItems: 'start'}}>
                <Text size={15} color={theme.Black} weight={"extrabold"}>Parámetros de terminados</Text>
                <Col style={{width: '100%', justifyContent: 'space-between'}}>
                    <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                        <SelectField theme={theme} control={control} name="dieCut" label = "Suaje" options={PRODUCTION_OPTIONS.suajeItems}/>
                        <Input theme={theme} control={control} name= "tool" label = "Herramienta"/>
                    </Row>
                    <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                        {format === "Caja" && <SelectField theme={theme} control={control} name="glue" label = "Pegado" options={PRODUCTION_OPTIONS.pegadoItems}/>}
                        {activeFinishes.includes("glueFlap") && 
                            <Col style={{alignItems: 'start', minWidth: 0}}>
                                <Text style={{marginBottom: 5}} color={theme.Black} size={15} weight={"medium"}>Largo ceja</Text>
                                <Controller name="glueFlap" control={control} render={({field: {onChange, value}, fieldState: {error}}) => (<TextContainer style={{width: '100%', height: 36, border: error ? `1.5px solid ${theme.Red}` : `1.5px solid ${theme.Coco}`}} suffix="mm" theme={theme} placeHolder="" value={value} onChange={onChange}/>)}/>
                            </Col>
                        }
                    </Row>
                    {activeFinishes.includes("coatingFinish") && (
                        <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                            <SelectField theme={theme} control={control} name="coatingFinish.line" label = "Barniz en línea" options={PRODUCTION_OPTIONS.barnizItems} multiple/>
                            <SelectField theme={theme} control={control} name="coatingFinish.application" label = "Aplicación barniz" options={PRODUCTION_OPTIONS.aplicBarnizItems} multiple/>
                            <SelectField theme={theme} control={control} name="coatingFinish.faces" label = "Caras con barniz" options={PRODUCTION_OPTIONS.carasBarnizItems} multiple/>
                        </Row>
                    )}
                    {activeFinishes.includes("lamination") && (
                        <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                            <SelectField theme={theme} control={control} name="laminationTxt.type" label = "Tipo de plastificado" options={PRODUCTION_OPTIONS.tipoPlastItems} multiple/>
                            <SelectField theme={theme} control={control} name="laminationTxt.application" label = "Aplicación plastificado" options={PRODUCTION_OPTIONS.aplicPlastItems} multiple/>
                            <SelectField theme={theme} control={control} name="laminationTxt.faces" label = "Caras con plastificado" options={PRODUCTION_OPTIONS.carasPlastItems} multiple/>
                        </Row>
                    )}

                </Col>
            </Col>
            {format !== "Flexo" && (
                <Col style={{alignItems: 'start', width: '100%', marginTop: 64}}>
                    <Text style={{marginBottom: 5, whiteSpace: 'nowrap'}} color={theme.Black} size={15} weight={"medium"}>Notas de especificaciones técnicas</Text>
                    <Controller name={"techNotes"} control={control} render={({field: {onChange, value}, fieldState: {error}}) => (<TextContainer multiline={true} style={{width: '100%', height: 106, border: error ? `1.5px solid ${theme.Red}` : `1.5px solid ${theme.Coco}`}} theme={theme} placeHolder="" value={value} onChange={onChange}/>)}/>
                </Col>
            )} 
            {format === "Flexo" && (
                <>
                    <Col style={{width: '100%', alignItems: 'start', marginTop: 64}}>
                        <Text size={15} color={theme.Black} weight={"extrabold"}>Guía de rebobinado</Text>
                        <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                            <SelectField theme={theme} control={control} name="rewindType" label = "Tipo de rebobinado" options={PRODUCTION_OPTIONS.rebobinadoItems}/>
                            <Input theme={theme} control={control} name= "labelsAcross" label = "Etiquetas al paso"/>
                            <Input theme={theme} control={control} name= "labelsXRoll" label = "Etquetas por rollo"/>
                        </Row>
                    </Col>
                    <Col style={{width: '100%', alignItems: 'flex-start', marginTop: 16, flex: 'none'}}>
                        <Text size={15} color={theme.Black} weight={"extrabold"}>Orientación de rebobinado</Text>
                        <Row style={{width: '100%', marginTop: 16, justifyContent: 'space-between', gap: '16px', flex: 'none', alignItems: 'stretch'}}>
                            <Controller name="rewindOrientation" control={control} render={({field: {value, onChange}}) => (
                                <>
                                    {RewindIcons.map((IconComponent, index) => (
                                        <div key={index} onClick={() => onChange(index)} style={{flex: 1, cursor: 'pointer', display: 'flex', padding: 0, margin: 0, transition: 'all .2s ease'}} onMouseEnter={(e) => e.currentTarget.style.filter = 'brightness(0.9)'} onMouseLeave={(e) => e.currentTarget.style.filter = 'brightness(1)'}>
                                            <IconComponent size="100%" selected={value === index}></IconComponent>
                                        </div>
                                    ))}
                                </>
                            )}/>
                        </Row>
                    </Col>
                </>
            )}
        </Col>
    )
}

export default TechSpecsEnd;